import { EditFilled } from '@ant-design/icons';
import TaggedTooltipButton, { TaggedTooltipButtonOwnProps } from '../TaggedTooltipButton';
import styles from './styles.module.less';

const TaggedEditButton = (props:TaggedTooltipButtonOwnProps) => {
  return (
    <TaggedTooltipButton {...props} className={styles['orange-btn']} icon={<EditFilled />} type="primary" />
  );
};

export default TaggedEditButton;
